export default function ThimEkitsReading() {
	if (document.getElementsByClassName( 'thim-ekits-js-progress' ).length > 0) {
		const html = document.documentElement;
		const progressBar = document.querySelector( '.thim-ekits-js-progress' );
		const progressUpdate = () => {
			const height = html.scrollHeight;
			const vh = html.clientHeight;
			progressBar.setAttribute( 'value', scrollY / ( height - vh ) * 100 );
		};

		const progressScroll = () => {
			const scrollY = html.scrollTop;
			if (scrollY > 0) {
				requestAnimationFrame( progressUpdate );
			} else {
				progressBar.setAttribute( 'value', 0 );
			}
		};

		const progressResize = () => requestAnimationFrame( progressUpdate );

		window.addEventListener( 'scroll', progressScroll, false );
		window.addEventListener( 'resize', progressResize, false );

	}
	if (document.getElementsByClassName( 'thim-ekit-single-post__content' ).length > 0 &&
		document.getElementsByClassName( 'thim-kits-time' ).length > 0) {
		var words = document.querySelector( '.thim-ekit-single-post__content' ).textContent.trim();
		var estimation = document.querySelector( '.thim-kits-time' );
		var results_text = estimation.getAttribute( 'data-results', 0 );

		function EstimateReadingTime( str, results_text ) {
			function WordCount( str ) {
				return str.split( ' ' ).length;
			}

			function Replace_text( times, results_text ) {
				return results_text.replace( '{times}', '<span class="number-time">' + times + '</span>' );
			}

			var conditon_times = Math.floor( ( ( WordCount( str ) / 200 ) * 60 ) / 60 ),
				second = Math.floor( ( WordCount( str ) / 200 ) * 60 ) + ekits_script.text_second,
				min_second = Math.floor( ( ( WordCount( str ) % 200 ) / 200 ) * 60 ) + ekits_script.text_second,
				minutes = Math.floor( ( WordCount( str ) / 200 ) ) + ekits_script.text_minutes;
			if (conditon_times < 1) {
				var times = second;
			} else {
				var times = minutes + '&nbsp;' + min_second;
			}
			return Replace_text( times, results_text );

		}

		estimation.innerHTML = EstimateReadingTime( words, results_text );
	}
}
